// src/modules/Admin/pages/AccessControlMobile/QRScanner.jsx
import React, { useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { BiX } from 'react-icons/bi';
import styles from './QRScanner.module.css';

export default function QRScanner({ onScan, onClose }) {
  const scannerRef = useRef(null);
  const runningRef = useRef(false);
  const containerId = 'qr-scanner-container';

  useEffect(() => {
    const html5QrCode = new Html5Qrcode(containerId);
    scannerRef.current = html5QrCode;

    // Запускаем сканер
    html5QrCode
      .start(
        { facingMode: 'environment' },
        { fps: 10, qrbox: 250 },
        decodedText => {
          onScan(decodedText);
          // останавливаем после первого скана
          if (runningRef.current) {
            html5QrCode
              .stop()
              .then(() => html5QrCode.clear())
              .catch(() => {})
              .finally(() => { runningRef.current = false; });
          }
        }
      )
      .then(() => {
        // старт прошёл успешно
        runningRef.current = true;
      })
      .catch(err => console.error('QR Scanner start error:', err));

    // При размонтировании
    return () => {
      if (runningRef.current) {
        html5QrCode
          .stop()
          .then(() => html5QrCode.clear())
          .catch(() => {})
          .finally(() => { runningRef.current = false; });
      }
    };
  }, [onScan]);

  const handleClose = () => {
    const html5QrCode = scannerRef.current;
    if (runningRef.current && html5QrCode) {
      html5QrCode
        .stop()
        .then(() => html5QrCode.clear())
        .catch(() => {})
        .finally(() => {
          runningRef.current = false;
          onClose();
        });
    } else {
      onClose();
    }
  };

  return (
    <div className={styles.overlay}>
      <button className={styles.closeBtn} onClick={handleClose}>
        <BiX size={24} />
      </button>
      <div id={containerId} className={styles.scanner} />
    </div>
  );
}
